var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.listClasses},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,class:_vm.itemClasses},[(!_vm.isSlots)?[_c('DSTextElement',[_vm._v(" "+_vm._s(item)+" ")])]:_vm._e(),_vm._t("list-item",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }